<template>
  <!-- 个人实名认证 -->
  <div class="person-auth-root">
    <div class="box">
      <!-- 步骤条 -->
      <div class="step-box">
        <div class="font-family font-26 step1">
          01基本信息
        </div>
        <div
          class="font-family font-26"
          :class="{
            'un-start': authStep == 1,
            doing: authStep > 1
          }"
        >
          02提交结果
        </div>
        <div></div>
      </div>
      <!-- 步骤条 end -->
      <!-- step1 基本信息 -->
      <div v-show="authStep == 1">
        <!-- 大陆居民 -->
        <mainland
          ref="inland"
          v-if="isContinent"
          :backUrl.sync="backUrl"
          :authStep="authStep"
          :isContinent.sync="isContinent"
          :APIAUTHINFO="APIAUTHINFO"
          @loadingStart="loadingStart"
          @loadingClose="loadingClose"
        ></mainland>
      </div>
      <div v-show="authStep === 2">
        <div style="margin: 100px 0; text-align: center">
          <img src="/images/auth/authIcon/suc.png" alt="" />
          <p style="margin: 20px 0; font-weight: bold; font-size: 16px">提交成功</p>
        </div>
      </div>
      <!-- 步骤按钮 -->
      <div class="step-btn">
        <el-checkbox v-model="agreement" v-show="authStep == 1">
          <span style="color: #666666">我已阅读并同意</span>
          <a
            class="showAgreement"
            style="color: #409EFF"
            href="javascript:void(0)"
            @click="showProtocol = true"
          >《实名认证服务协议》</a
          >
          <a
            class="showAgreement"
            style="color: #409eff"
            href="javascript:void(0)"
            @click="showPrivacyProtocol = true"
          >《用户隐私政策协议》</a>
          <a
            class="showAgreement"
            style="color: #409eff"
            href="javascript:void(0)"
            @click="showNumberProtocol = true"
          >《数字证书服务协议》</a>
        </el-checkbox>
        <div style="margin-top:20px">
          <el-button type="danger" v-show="authStep == 1" @click="nextStep"
          >提交认证</el-button
          >
<!--          <el-button type="danger" v-show="authStep == 1" @click="authSubmit"-->
<!--          >提交认证11</el-button-->
<!--          >-->
          <el-button type="danger" v-show="authStep == 2 && APIAUTHINFO.backUrl" @click="authSuc">完成（{{countdownTime}}s）</el-button>
        </div>
      </div>
      <el-dialog
        title="提示"
        :visible.sync="APIAUTHINFO.code === '10214'"
        :show-close="false"
        width="30%">
        <span>链接失效，请重新获取认证链接</span>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
      <!-- 基本信息 end -->
      <real-name-protocol
        :visible.sync="showProtocol"
        type="register"
      ></real-name-protocol>
      <!-- 隐私政策协议 -->
      <privacy-protocol :visible.sync="showPrivacyProtocol" type="register"></privacy-protocol>
      <!-- 数字证书服务协议 -->
      <number-protocol :visible.sync="showNumberProtocol" type="register"></number-protocol>
    </div>
  </div>
</template>

<script>
  /* 组件 */
  import RealNameProtocol from "../components/protocol/RealName.vue";
  import PrivacyProtocol from "../components/protocol/Privacy.vue";
  import NumberProtocol from "../components/protocol/Number";
  // 基础信息
  import mainland from "./components/mainland.vue";
  // 接口
  import {ApiMethods} from "@/assets/js/http-serve/http-methods";
  import { loginOrRefresh } from "@/assets/js/http-serve/corp/common";
  import { isInDingTalk } from '@/assets/js/utils/ding-env';
  import { isMobileDevice } from "@/assets/js/utils/others";
  const FACE=1,BANK=2,OPER=3;
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        countdownTime: 3,
        APIAUTHINFO:{code: ''}, // 认证信息
        aliCaptchaParam:{
          handCallback:null,
          targetId:'',
          verifyType:null
        }, // 验证码实例参数
        backUrl: "", // 认证成功后跳转地址
        // step1
        isContinent: true, // 是否内陆居民
        authStep: 1, // 步骤
        showProtocol: false,
        showPrivacyProtocol:false,
        showNumberProtocol:false,
        agreement: false, // 已阅读并同意
        userInfo: {}, // 基本信息
        // step2
        authentication: 1, // 认证方式
        authStatus: -1, // 认证状态 // 0待审核 1审核通过 2审核不通过 -1未提交资料 ( 2 -1 不做操作视为未实名)
        authTypes: [
          { key: FACE, label: "人脸识别" },
          { key: BANK, label: "银行卡认证" },
          { key: OPER, label: "运营商认证" }
        ],
        QRCodeVisible: false,
        QRCodeValue: "",
        // 接口
        authApi: ApiMethods.IdenAuthController
      };
    },
    // data end
    methods: {
      /** 触发阿里验证 */
      verifyHandle(params){
        this.aliCaptchaParam={...params}
        this.$nextTick(()=>{
          // 获取到验证码组件ref
          const aliCaptchaRef = this.$refs.aliCaptchaRef
          // 触发验证码组件点击事件
          aliCaptchaRef.click()
        })
      },
      /** 获取认证信息 */
      getAuthInfo(){
        this.loadingStart()
        const { multiSignatoryKey } = this.$route.query;
        ApiMethods.IdenAuthController.advancedAuthInfo({ multiSignatoryKey }).then(
          res => {
            if (!res.success){
              this.APIAUTHINFO.code = res.code;
              return this.$message.error(res.description);
            }
            this.APIAUTHINFO = res.data
            const {authorized,linkType} = res.data,turnPath = '/auth/APIAuth/AuthRes/AuthResult';
            // 流程完成提示完成
            if(authorized && authorized == 1 ) {
              this.$alert('该账号认证已完成', '提示', {
                confirmButtonText: '确定',
                callback: action => {}
              });
              return
            }
            // 判断是否已经实名认证
            const {accountInfoVO} = this.allAuthUser
            // 说明已经实名认证，要授权跳转授权，要回调去回调
            // if(accountInfoVO && accountInfoVO.identityAuth === 1){
            //   this.authStep = 3
            //   this.turnPage()
            // }
            // 如果仅授权，跳转到授权页面
            if(linkType === 2) return this.$router.push({path:turnPath,query:{...this.$route.query} })
          }
        ).finally(()=>{this.loadingClose()})
      },
      // 跳转页面
      turnPage() {
        const { multiSignatoryKey } = this.$route.query,{linkType,backUrl} = this.APIAUTHINFO;
        if (this.APIAUTHINFO.sourceType === 'jzqYwt') {
          this.$message.success('认证成功');
          setTimeout(() => {
            window.location.href = this.globalConfig.domain.ywtOrigin + '/index.html';
          }, 2000)
        } else if (linkType == 1){
          this.$router.push({path:'/auth/APIAuth/AuthRes/AuthResult',query:{...this.$route.query} })
        }else if(backUrl) window.location.href = backUrl;
      },
      // 上一步
      peveStep() {
        // 调用子组件清空表单方法
        this.$refs.inlandAuth && this.$refs.inlandAuth.resetFields();
        this.$refs.islandAuth && this.$refs.islandAuth.resetFields();
        this.authStep = --this.authStep;
        this.authTypes.forEach(item => item.disabled = this.radioDis(item.key))
        const list = this.authTypes.filter(item => !item.disabled)
        this.authentication= list[0].key
      },
      // 下一步
      async nextStep() {
        if (!this.agreement) {
          return this.$message.warning("请先阅读并同意《实名认证服务协议》！");
        }
        let cardInfo = await this.$refs.inland.checkCard();
        this.userInfo = cardInfo;

        if (cardInfo) {
          const { userInfo: user } = this,{multiSignatoryKey} = this.$route.query;
          const params = {
            multiSignatoryKey,
            name: user.idName,
            identityNo: user.idNo,
            personalFront: user.card_face.targetId,
            personalVerso: user.card_back.targetId
          }
          ApiMethods.IdenAuthController.personalSubmitDocuments(params).then(res => {
            if (res.success) {
              this.authentication = this.isContinent ? 1 : 2; // 认证方式
              this.authStep = ++this.authStep;
              this.countdownTimeFn()
            } else {
              this.$message.error(res.description)
            }
          })
        }
      },
      //倒计时
      countdownTimeFn() {
        if (!this.APIAUTHINFO.backUrl) {
          return false
        }
        const times = setInterval(() => {
          if (this.countdownTime < 1) {
            clearInterval(times);
            this.authSuc();
          } else {
            this.countdownTime--;
          }
        }, 1000)
      },
      authSubmit() {
        // 判断认证类型 authentication 1 人脸识别  2 银行卡认证  3运营商认证  4 无银联银行卡
        if (this.isContinent) {
          // 内陆居民
          switch (this.authentication) {
            case 1:
              this.ofFace();
              return;
            case 2:
              this.ofBank();
              return;
            case 3:
              this.ofOperator();
              return;
            default:
              return;
          }
        } else {
          // 非内陆居民
      this.ofBank();
        }
      },
      // 人脸认证
      async ofFace() {
        const info = await this.$refs.inlandAuth.submitInfo();
        if (!info) return;
        this.loadingStart();
        const { userInfo: user } = this,{multiSignatoryKey} = this.$route.query;
        const params = {
          name: user.idName,
          idenCard: user.idNo,
          personalFront: user.card_face.targetId,
          personalVerso: user.card_back.targetId
        };
        if(multiSignatoryKey) params.multiSignatoryKey = multiSignatoryKey;
        this.authApi
          .faceUrl(params)
          .then(result => {
            if (result.success) {
              // window.location.href = result.data;
              this.QRCodeVisible = true;
              this.QRCodeValue = result.data;
            } else {
              this.$message.error(result.description || this.$tip);
            }
          })
          .finally(() => {
            this.loadingClose();
          });
      },
      // 刷新人脸识别二维码
      faceRefresh() {
        // this.QRCodeRefresh = false;
        const { userInfo: user } = this;
        let param = {
          name: user.idName,
          idenCard: user.idNo,
          personalFront: user.card_face.targetId,
          personalVerso: user.card_back.targetId,
          backUrl: "",
          failUrl: ""
        };
        this.authApi
          .faceUrl(param)
          .then(result => {
            if (result.success) {
              this.QRCodeVisible = true;
              this.QRCodeValue = result.data;
            } else {
              this.$message.error(result.description || this.$tip);
            }
            // this.QRCodeRefresh = true;
          })
          .catch(err => {
            // ow.close();
            // this.QRCodeRefresh = true;
          });
      },
      // 查询是否人脸认证成功
      circleCallback() {
        let timer = setInterval(() => {
          if (!this.QRCodeVisible) {
            clearInterval(timer);
            return;
          }
          ApiMethods.ProfileController.profile({}).then(res => {
            if (
              res.success &&
              res.data.accountInfoVO &&
              res.data.accountInfoVO.identityAuth === 1
            ) {
              clearInterval(timer);
              // 认证成功
              this.QRCodeVisible = !this.QRCodeVisible;
              this.authStep = 2;
              this.turnPage();
            }
          });
        }, 2000);
      },
      // 已完成实名认证
      faceComplete() {
        ApiMethods.ProfileController.profile({})
          .then(result => {
            if (result.success) {
              // 已完成
              if (
                result.data.accountInfoVO &&
                result.data.accountInfoVO.identityAuth === 1
              ) {
                // 认证成功
                this.QRCodeVisible = !this.QRCodeVisible;
                this.authStep = 2;
                this.turnPage();
              } else {
                this.$message.error("认证还未完成");
              }
            } else {
              this.$message.error(result.description || this.$tip);
            }
          })
          .catch(err => {
            // ow.close();
          });
      },
      // 银行卡认证
      async ofBank() {
        const bankInfo = this.isContinent
          ? await this.$refs.inlandAuth.submitInfo()
          : await this.$refs.islandAuth.submit();
        if (!bankInfo) return;
        this.loadingStart("正在进行验证，请稍等......");
        const { userInfo: user } = this,{multiSignatoryKey} = this.$route.query;
        let params = "";
        if (this.isContinent) {
          // 内陆银行卡认证
          params = {
            name: user.idName,
            identityNo: user.idNo,
            personalFront: user.card_face.targetId,
            personalVerso: user.card_back.targetId,
            ...bankInfo
          };
        } else {
          params = {
            ...this.userInfo,
            ...bankInfo,
            // 银行卡认证（非身份证） 添加 identityType
            identityType: this.userInfo.cardType,
            identityNo: this.userInfo.card
          };
        }
        if(multiSignatoryKey) params.multiSignatoryKey = multiSignatoryKey;
        console.log(params);
        this.authApi.personalBankAuth(params).then(result => {
          if (result.success) {
            // 成功后进入认证成功页
            this.authStep = ++this.authStep;
            this.turnPage();
          } else {
            this.$message.error(result.description || this.$tip);
          }
          this.loadingClose();
        });
      },
      // 银行卡认证（非身份证）
      async ofBankWithoutId() {
        const bankInfo = await this.$refs.islandAuth.submit();
        if (!bankInfo) return;
        this.loadingStart("正在进行验证，请稍等......");
        const { userInfo: user } = this;
        let params = {
          ...this.userInfo,
          ...bankInfo,
          identityNo: this.userInfo.card
        };
        console.log(params);
        this.authApi.personalBankAuth(params).then(result => {
          if (result.success) {
            // 成功后进入认证成功页
            this.authStep = ++this.authStep;
          } else {
            this.$message.error(result.description || this.$tip);
          }
          this.loadingClose();
        });
      },
      // 运营商认证
      async ofOperator() {
        const mobileInfo = await this.$refs.inlandAuth.submitInfo();
        if (!mobileInfo) return;
        this.loadingStart("正在进行验证，请稍等......");
        const { userInfo: user } = this,{multiSignatoryKey} = this.$route.query;
        const params = {
          name: user.idName,
          identityNo: user.idNo,
          personalFront: user.card_face.targetId,
          personalVerso: user.card_back.targetId,
          ...mobileInfo
        };
        if(multiSignatoryKey) params.multiSignatoryKey = multiSignatoryKey;
        this.authApi.personalOperatorAuth(params).then(result => {
          if (result.success) {
            this.authStep = ++this.authStep;
            this.turnPage();
          } else {
            this.$message.error(result.description || this.$tip);
          }
          this.loadingClose();
        });
      },
      // 非大陆居民无银行卡认证
      async islandBank() {
        const info = await this.$refs.islandAuth.submit();
        if (!info) return;
        this.loadingStart("正在进行验证，请稍等......");
        const {
          name,
          card,
          cardType,
          frontIdentityCard,
          backIdentityCard
        } = this.userInfo,{multiSignatoryKey} = this.$route.query;
        const params = {
          name,
          card,
          cardType,
          frontIdentityCard, // 证件a面
          backIdentityCard, // 证件b面
          valicode: info.valicode, // 验证码
          mobilePhone: info.mobileNo,
          identityCardImg: info.targetId // 手持证件照
        };
        if(multiSignatoryKey) params.multiSignatoryKey = multiSignatoryKey;
        this.authApi
          .islandApprove(params)
          .then(res => {
            if (res.success) {
              this.authStep = 2;
            } else {
              this.$message.error(res.description);
            }
          })
          .finally(() => {
            this.loadingClose();
          });
      },
      // 做认证方式显示
      radioShow(key) {
        if (this.isContinent) {
          /*
          大陆居民 显示
          { key: 1, label: "人脸识别" },
          { key: 2, label: "银行卡认证" },
          { key: 3, label: "运营商认证" }
          */

          return [FACE,BANK,OPER].includes(key);
        } else {
          // 非大陆居民 { key: 2, label: "银行卡认证" }, { key: 4, label: "无银联银行卡" }
          return [BANK,UNION].includes(key);
        }
      },
      /** 认证方式禁用逻辑 可用认证方式取反就是不禁用 */
      radioDis(key){
        const {linkType,authType} = this.APIAUTHINFO;
        switch (key) {
          // 人脸识别
          case FACE:
            return !([0,1].includes(linkType) && [0,1].includes(authType));
          // 银行卡
          case BANK:
            return !([0,1].includes(linkType) && [0,2].includes(authType));
          // 运营商认证
          case OPER:
            return !([0,1].includes(linkType) && [0,3].includes(authType));
          // 无银联银行卡
          case UNION:
            return !([0,1].includes(linkType) && [0,2].includes(authType));;
          default:
            break;
        }
      },
      // 认证成功3点击完成
      authSuc() {
        window.location.href = this.APIAUTHINFO.backUrl
      },
      loadingStart(info = null) {
        this.loading = this.$loading({
          lock: true,
          text: info || "正在拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, .5)"
        });
      },
      //设置状态
      loadingClose() {
        if (this.loading) {
          this.loading.close();
          this.loading = null;
        }
      }
    },
    // methods end
    components: {
      RealNameProtocol,
      mainland,
      PrivacyProtocol,
      NumberProtocol
    },
    // components end
    computed: {
      ...mapGetters(["allAuthUser"])
    },
    mounted() {
      this.getAuthInfo()
    },
    created(){
      const isMobile = isMobileDevice(),{multiSignatoryKey} = this.$route.query;
      if(isMobile) {
        window.location.href=`${this.globalConfig.domain.junziqianH5Op}/auth/APIAuth/justRegister?multiSignatoryKey=${multiSignatoryKey}`
      }
    },
    layout: "fullpage"
  };
</script>

<style scoped lang="less">
  .person-auth-root {
    width: 100%;
    height: 85vh;
    padding: 10px;
    overflow: auto;
    background-color: #fff;
    .box {
      width: 1000px;
      margin: 0 auto;
      // step3
      .stpe-end {
        height: 45vh;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        .res-icon {
          > div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .text {
            font-size: 1.3vw;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #555555;
            margin-top: 20px;
          }
        }
      }
      // step2
      .stpe-mainland {
        padding-top: 20px;
        .step2-box {
          margin-top: 20px;
          border: 1px solid #e5e5e5;
        }
        .face-auth {
          padding: 20px;
        }
      }
      // btn
      .step-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 10px auto;
        > div {
          display: flex;
        }
      }
      .step-box {
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        > div {
          width: 260px;
          height: 61px;
          line-height: 61px;
          text-align: center;
        }
      }
      .step1 {
        background-image: url("/images/auth/authIcon/step1.png");
        background-size: cover;
      }
      .doing {
        background-image: url("/images/auth/authIcon/doing.png");
        background-size: cover;
      }
      .un-start {
        background-image: url("/images/auth/authIcon/un-start.png");
        background-size: cover;
      }
      .font-family {
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      .font-26 {
        font-size: 26px;
      }
    }
  }
  .el-radio.is-bordered.is-checked {
    border-color: #d12128;
  }
</style>



// WEBPACK FOOTER //
// pages/auth/APIAuth/justRegister/index.vue